import React, { useState } from 'react';

import statLabelMap from '../data/statLabelMap';
import statInfoText from '../data/statInfoText';

const localStatLabelMap = {
  ...statLabelMap,
  // Overrides for better clarity
  ATKPercent: "ATK Percent",
  SpecificATKPercent: "Attack Damage Boost",
  DMGTaken: "Enemy Damage Taken",
  TotalDMG: "Total Damage"
};


const noPercent = ['ATK', 'ElementalATK', 'DEF', 'HP', 'MoveSpd', "FlatBoost", "FlatATK", "FlatDEF", "FlatHP"];



const StatDisplay = ({ statKey, calculatedStats, label, categories }) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);



  const { stats, sources } = calculatedStats;
  const statValue = stats[`true${statKey}`] ?? stats[`display${statKey}`] ?? stats[statKey];

  return (
    <div className="statContainer">
      <div className="statWindow" onClick={toggleOpen}>
        <img src={`./img/Icons/Stats/${statKey}.webp`} className="statIcon" alt={statKey} />
        <span className="statText">{localStatLabelMap[label] || label}: {Number(statValue.toFixed(4))} {!noPercent.includes(label) && '%'}</span>

        {/* add a gap */}
        <pre> </pre> 
        <span className="button">{open ? '▲' : '▼'}</span>
      </div>

      {open && (
        <>
        {statInfoText[statKey] && (<div className="statInfoText">{statInfoText[statKey]}</div>)}
        <div className="sourceDropdown">
          {Object.entries(categories).map(([categoryLabel, sourceKeys]) => {
            const hasValidStats = sourceKeys.some(
              key => sources[key] && sources[key].length > 0
            );

            if (!hasValidStats) return null;

            return (
              <div className="sourceCategory" key={categoryLabel}>
                <div className="categoryLabel">
                  {categoryLabel}
                </div>
                {sourceKeys.map(key =>
                  sources[key] && (
                    <div key={key}>
                      <strong>-{localStatLabelMap[key] || key}:</strong>
                      {sources[key].map((entry, idx) => {
                        const isPercent = !noPercent.includes(key);
                        const hasValue = entry.amount > 0;
                        const valueDisplay = `${hasValue ? "+" : " "}${Number(entry.amount.toFixed(4))}${isPercent ? "%" : ""}`;

                        return (
                          <div key={idx} className="statLine">
                            <span className="valueCell">{valueDisplay}</span>
                            <span className="sourceCell">from {entry.source}</span>
                          </div>
                        );
                      })}
                    </div>
                  )
                )}
              </div>
            );
          })}
        </div>
      </>)}
    </div>
  );
};

export default StatDisplay;
